import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonTitle, IonToolbar } from "@ionic/react"
import { closeOutline } from "ionicons/icons"

import "./MLKitScanner.scss"
import { RefObject } from "react"
import { useTranslation } from "react-i18next"

interface MLKitScannerProps { modal: RefObject<HTMLIonModalElement> }

const MLKitScanner: React.FC<MLKitScannerProps> = ({ modal }: MLKitScannerProps) => {
    const { t } = useTranslation();
    return (
        <>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{t("QR-Code scannen")}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => modal.current?.dismiss()}>
                            <IonIcon icon={closeOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <div id="qrSquare" className="qrSquare"></div>
            </IonContent>
        </>
    )

}
export default MLKitScanner;